import(/* webpackMode: "eager" */ "/app/src/app/(frontend)/not-found.tsx");
